import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const CustomDatePicker = ({ name, label, selectedDate, setValue, onChange }) => {
    // State to manage the selected date
    const [currentDate, setCurrentDate] = useState(undefined);

    if (typeof currentDate === "undefined" && selectedDate) {
        setCurrentDate(selectedDate)
    }

    const handleDateChange = (date) => {
        setCurrentDate(date);
        setValue(name, date);
    };

    return (
        <div className="mb-3 flex items-center w-full">
            <label className="w-1/6 text-uidarker font-medium pr-6 text-right">{label}:</label>
            <DatePicker
                selected={currentDate}
                onChange={handleDateChange}
                className="bg-uilight border-solid border-2 border-uidark rounded-full py-1 px-4 w-full max-w-xs"
            />
        </div>
    );
};

export default CustomDatePicker;
